<template>
    <div class="sensitiveTextareaContainer" :class="{isfocus:isFocus}">
        <div
            id="sensitiveTextarea"
            class="sensitiveTextarea"
            :class="{'placeholder': placeholderShow }"
            ref="editable"
            contenteditable
            tabindex="1"
            :data-placeholder="placeholder"
            @focus="handleFocus"
            @blur="handleBlur"
            @input="handleInput"
            @keydown="handleKeyDown"
            @paste="handlePaste"
            @compositionstart="compositStart"
            @compositionend="compositEnd"
            v-html="highlightedContent"
        ></div>
        <span class="wordLimit" v-if="showWordLimit">{{ value.length }}/{{ maxlength }}</span>
    </div>
</template>
  
<script>
export default {
    name: "SensitiveTextarea",
    props: {
        value: {
            type: String,
            default: "",
        },
        sensitiveWords: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: "",
        },
        maxlength: {
            type: Number,
            default: "",
        },
        showWordLimit:{
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            content:this.value,
            highlightedContent: "",
            highlightedWords:[],
            lastSelection: null,
            placeholderShow: false,
            isComposing: false, // 处理中文输入法状态
            lastContent:'',//最后一次输入后的内容,
            isFocus:false,
        };
    },
    watch: {
        value(newVal) {
            if(this.content !== newVal){
                this.content = newVal
                this.highlightedContent = newVal; 
                this.highlightText();
                if(!this.highlightedContent){
                    this.placeholderShow = false;
                } 
            }
        },
        sensitiveWords(newVal) {
            this.highlightedWords = newVal;
            this.highlightText();
        }
    },
    created(){
        this.highlightedWords = this.sensitiveWords;
        this.highlightedContent=this.value;
        this.highlightText();
    },
    mounted() {
        
    },
    methods: {
        // 输入中文开始时
        compositStart(e) {
            this.isComposing = true;
        },
        // 输入中文结束时
        compositEnd(e) {
            this.isComposing = false;
            this.handleInput(e);
        },
        handleFocus(){
            this.isFocus=true;
            this.$emit('handleFocus')
        },
        handleBlur(){
            this.isFocus=false;
            this.cleanContent();
            this.updatePlaceholderState(this.$refs.editable.innerHTML)
            this.$emit("handleBlur");
        },
        // 检查是否是真正的空内容
        isReallyEmpty(html, textContent) {
            // 纯文本长度为0才可能是空内容
            if (textContent.length > 0) return false;
            // 常见空内容情况
            const emptyCases = [
                '', 
                '<br>', 
                '<div><br></div>', 
                '<p><br></p>',
                '<div><br class="Apple-interchange-newline"></div>',
                '<br class="Apple-interchange-newline">'
            ];
            // 检查是否是这些空内容情况之一
            return emptyCases.some(emptyCase => {
                // 完全匹配或包含特殊情况（如Safari的br）
                return html === emptyCase || (html.includes('Apple-interchange-newline') && html.replace(/\s+/g, '') === '<br class="Apple-interchange-newline">');
            });
        },
        // 更新placeholder状态
        updatePlaceholderState(html) {
            // 创建临时div来解析HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;         
            // 获取纯文本内容（去除所有空白字符）
            const textContent = (tempDiv.textContent || tempDiv.innerText || '').replace(/\s+/g, '');       
            // 检查是否是真正的空内容（包括各种浏览器生成的换行符情况）
            const isEmpty = this.isReallyEmpty(html, textContent);
            this.placeholderShow = isEmpty;
        },
        // 在输入和删除时调用此方法清理内容
        cleanContent() {
            const html = this.$refs.editable.innerHTML;
            if (this.isReallyEmpty(html, (html.replace(/<[^>]*>/g, '')))) {
                this.$refs.editable.innerHTML = '';
            }
        },
        handleInput(e) {
            if (this.isComposing) return;
            this.cleanContent();
            const content = this.getTextContent(e.target);
            if(content.length>this.maxlength){
                // 超出限制，恢复上一次有效内容
                e.target.innerHTML = this.lastContent;
                // 更新后恢复光标
                this.textFocus();
                //this.$nextTick(() => this.restoreSelection());
            }else{
                // 更新有效内容
                this.lastContent = e.target.innerHTML;
            }
            this.content=e.target.innerText.substring(0,this.maxlength);
            // 更新placeholder状态
            this.updatePlaceholderState(e.target.innerHTML);
            this.$emit("input", this.content);
            // 保存当前光标位置 
            this.saveSelection();
            // 如果有敏感词，实时高亮 
            if (this.highlightedWords.length>0)  {
                this.highlightText(); 
            }
        },
        handleKeyDown(e) {
            // 处理换行，防止默认行为
            if (e.key === "Enter") {
                document.execCommand("insertLineBreak");
                e.preventDefault();
            }
        },
        handlePaste(e){
            // 保存当前光标位置 
            this.saveSelection();
            const content = this.getTextContent(e.target);
            // if (content.length >= this.maxlength) {
            //     e.preventDefault();
            //     return;
            // }
            // 获取粘贴文本
            const pastedText = (e.clipboardData || window.clipboardData).getData('text/plain');
            //获取当前是否有选中的内容
            const selection = window.getSelection();
            //当前还可以输入多少字符
            let remaining;
            const range = selection.getRangeAt(0);
            if(selection.rangeCount > 0){//有选中的先删除选中的在复制
                //选中字符串的长度
                const selectTextLength=selection.toString().length;
                remaining=this.maxlength - (content.length-selectTextLength)
            }else{
                remaining=this.maxlength - content.length; 
                if (remaining <= 0) {
                    e.preventDefault();
                    return;
                }
            }
            // 只粘贴剩余可输入的部分
            if (pastedText.length > remaining) {
                e.preventDefault();
                range.deleteContents();
                range.insertNode(document.createTextNode(pastedText.substring(0, remaining)));
                range.collapse(false);
                // 触发input事件更新状态
                this.$nextTick(() => {
                    this.handleInput({ target: this.$refs.editable });
                });
            }
        },
        highlightText(){
            let highlighted = this.content; 
            // 转义正则特殊字符 
            const escapeRegex =(string)=> {
                return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
            };
            this.highlightedWords.map(word => {
                const regex = new RegExp(escapeRegex(word), 'gi')
                highlighted = highlighted.replace(
                    regex, 
                    match => `<span style="color: #000; font-weight:bold">${match}</span>`
                )
                this.highlightedContent  = highlighted;
            })                
            // 更新后恢复光标 
            if(this.content.length==this.maxlength){
                this.textFocus();
            }else{
                this.$nextTick(() => this.restoreSelection());
            }
            
        },
        getTextContent(element) {
            // 获取纯文本内容（忽略HTML标签）
            return element.innerText || element.textContent;
        },
        saveSelection() {
            const sel = window.getSelection(); 
            if (sel.rangeCount  === 0) {
                this.lastSelection  = null;
                return;
            }
            const range = sel.getRangeAt(0); 
            const preRange = range.cloneRange(); 
            preRange.selectNodeContents(this.$refs.editable); 
            preRange.setEnd(range.startContainer,  range.startOffset); 
            const start = preRange.toString().length; 
            this.lastSelection  = {
                start,
                end: start + range.toString().length  
            };
        },
        restoreSelection() {
            if (!this.lastSelection)  return;
            const { start, end } = this.lastSelection; 
            let charIndex = 0;
            let startNode, startOffset, endNode, endOffset;
            const walker = document.createTreeWalker(this.$refs.editable,  NodeFilter.SHOW_TEXT, null, false);
            let node;
            // 查找起始位置 
            while ((node = walker.nextNode()))  {
                const length = node.textContent.length; 
                if (charIndex + length >= start) {
                    startNode = node;
                    startOffset = start - charIndex;
                    break;
                }
                charIndex += length;
            }
            // 查找结束位置 
            charIndex = 0;
            walker.currentNode  = this.$refs.editable; 
            while ((node = walker.nextNode()))  {
                const length = node.textContent.length; 
                if (charIndex + length >= end) {
                    endNode = node;
                    endOffset = end - charIndex;
                    break;
                }
                charIndex += length;
            }
            if (startNode && endNode) {
                const range = document.createRange(); 
                range.setStart(startNode,  startOffset);
                range.setEnd(endNode,  endOffset);
                const sel = window.getSelection(); 
                sel.removeAllRanges(); 
                sel.addRange(range); 
            }
        },
        // 文本输入框聚焦，焦点在最后位置
        textFocus() {
            setTimeout(() => {
                document.querySelector("#sensitiveTextarea").focus();
                document.execCommand("selectAll", false, null);
                document.getSelection().collapseToEnd();
                this.$refs.editable.scrollTop = this.$refs.editable.scrollHeight;
            }, 0);
        },
    },
};
</script>
<style scoped lang="scss">
.sensitiveTextareaContainer{
    border:1px solid #DCDFE6;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding-bottom: 20px;
    height: 170px;
    border-radius: 8px;
    position: relative;
    &:hover {
        border-color: #C0C4CC;
    }
    &.isfocus {
        outline: none;
        border-color: #8B9EFF;
    }
    .sensitiveTextarea{
        flex: 1;
        background: none;
        overflow: auto;
        word-break: break-all;
        border: none;
        outline: none;
        -webkit-user-modify:read-write-plaintext-only;
        padding: 10px 12px 0;
        border-radius: 8px;
        font-size: 14px;
        line-height: 1.4;
    }
    .placeholder{
        &::after{
            content: attr(data-placeholder);
            color: #C0C4CC;
            font-size: 14px;
        }
    }
    .wordLimit{
        position: absolute;
        right: 10px;
        bottom: 5px;
        font-size: 12px;
        color: #8B9EFF;
    }
}
.is-error{
    .sensitiveTextareaContainer{
        border-color:#f56c6c;
    }
}
</style>
  